import { render } from "./PlayerInformationsPage.vue?vue&type=template&id=2448b268&scoped=true"
import script from "./PlayerInformationsPage.vue?vue&type=script&lang=js"
export * from "./PlayerInformationsPage.vue?vue&type=script&lang=js"

import "./PlayerInformationsPage.vue?vue&type=style&index=0&id=2448b268&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2448b268"]])

export default __exports__